export default __webpack_public_path__ + "locales/vi/Settings.json?hash=aee7bc0b63c76790481b070311466ddf";